// CI workflow deployment verification
import React, { createContext, useState, ReactNode, useMemo } from 'react';

export interface InviteValidationContextType {
  isInviteValidating: boolean;
  setIsInviteValidating: (isValidating: boolean) => void;
}

const InviteValidationContext = createContext<
  InviteValidationContextType | undefined
>(undefined);

export const InviteValidationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const isOnInviteRoute = () => {
    const currentPath = globalThis.location.pathname;
    const searchParams = new URLSearchParams(globalThis.location.search);
    const hasInviteParams =
      searchParams.get('email') &&
      searchParams.get('token') &&
      searchParams.get('org_id');

    return currentPath.includes('/invite/accept') && !!hasInviteParams;
  };

  const [isInviteValidating, setIsInviteValidating] =
    useState(isOnInviteRoute());

  const contextValue = useMemo(
    () => ({
      isInviteValidating,
      setIsInviteValidating,
    }),
    [isInviteValidating],
  );

  return (
    <InviteValidationContext.Provider value={contextValue}>
      {children}
    </InviteValidationContext.Provider>
  );
};

export default InviteValidationContext;
